var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c("div", { staticClass: "spinner-container" }, [
        _c("div", { staticClass: "spinner" })
      ])
    : !_vm.selectedProduct
    ? _c("productsCollection")
    : _c("productModal", { attrs: { curatedBox: _vm.selectedProduct } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }